import type { ReactNode } from 'react';

type Tone = 'error' | 'warning' | 'success' | 'info';

const TONES: Record<Tone, { bg: string; border: string; fg: string }> = {
  error: { bg: 'var(--error-soft)', border: 'var(--error)', fg: 'var(--error)' },
  warning: { bg: 'var(--warning-soft)', border: 'var(--warning)', fg: '#8A5A12' },
  success: { bg: 'var(--success-soft)', border: 'var(--success)', fg: 'var(--success)' },
  info: { bg: 'var(--accent-subtle)', border: 'var(--accent-soft)', fg: 'var(--text-secondary)' },
};

export interface AlertProps {
  tone?: Tone;
  title?: string;
  children?: ReactNode;
}

export function Alert({ tone = 'info', title, children }: AlertProps) {
  const t = TONES[tone];
  return (
    <div
      // Errors should interrupt a screen reader; the quieter tones shouldn't.
      role={tone === 'error' ? 'alert' : 'status'}
      style={{
        background: t.bg,
        border: `1px solid ${t.border}`,
        borderRadius: 'var(--r-md)',
        padding: 'var(--sp-3) var(--sp-4)',
        fontSize: 'var(--fs-body-sm)',
        color: 'var(--text)',
        lineHeight: 1.45,
      }}
    >
      {title && (
        <div
          style={{
            fontFamily: 'var(--font-display)',
            fontWeight: 700,
            color: t.fg,
            marginBottom: children ? 'var(--sp-1)' : 0,
          }}
        >
          {title}
        </div>
      )}
      {children}
    </div>
  );
}
